import {css} from '@yandex-delivery/blocks/theme/css'
import {theme} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  wrapper: css`
    padding: 0 ${theme.spacing(2)}px ${theme.spacing(2)}px;
    display: flex;
    height: 100%;
    flex-direction: column;
  `,
  title: css`
    font-size: 24px;
    font-weight: 500;
    line-height: 27px;
    padding-top: ${theme.spacing(2)}px;
    color: var(--colorScheme-text, #21201f);
  `,
  input: css`
    padding-top: ${theme.spacing(2)}px;
  `,
  button: css`
    margin-top: auto;
    justify-self: flex-end;

    :global(html[data-theme='dark']) & {
      background-color: #fce000 !important;
      color: #21201f !important;
    }
  `,
}
